import * as types from '../mutation-types'
import constants from 'assets/js/constants.js'
import moment from 'moment/moment.js'

const state = JSON.parse(localStorage.getItem('dashboard_filter')) || getDefaultFilter()

const mutations = {
  [types.DASHBOARD_RESET_FILTER] (state) {
    let defaultFilter = getDefaultFilter()
    state.mode = defaultFilter.mode
    state.startDate = defaultFilter.startDate
    state.endDate = defaultFilter.endDate
    state.startDateFmt = defaultFilter.startDateFmt
    state.endDateFmt = defaultFilter.endDateFmt
    state.client = defaultFilter.client
    state.fetchData = defaultFilter.fetchData
    localStorage.removeItem('dashboard_filter')
  },
  [types.DASHBOARD_SET_FILTER_DATE] (state, filter) {
    state.mode = filter.mode
    state.startDate = filter.startDate
    state.endDate = filter.endDate
    state.startDateFmt = filter.startDateFmt
    state.endDateFmt = filter.endDateFmt
    localStorage.setItem('dashboard_filter', JSON.stringify(state))
  },
  [types.DASHBOARD_SET_FILTER_CLIENT] (state, client) {
    state.client = client
    localStorage.setItem('dashboard_filter', JSON.stringify(state))
  }
}

function getDefaultFilter () {
  let curentDate = moment()
  return {
    mode: constants.dashboardFilterModes.today,
    startDate: curentDate.format('YYYYMMDD'),
    endDate: curentDate.format('YYYYMMDD'),
    startDateFmt: curentDate.format('DD/MM/YYYY'),
    endDateFmt: curentDate.format('DD/MM/YYYY'),
    client: null
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/dashboardFilter.js